<template>
    <div class="root">
      <div class="content">
        <NavigationBar/>
        <img src="../assets/tangerine-logo.svg" width="140" height="140" >

        <div class="row mx-5">
        <div class="col-12 col-md-7 mb-2">
        <ProductList :products="this.$store.state.cart"/>
      </div>
      <div class="col-12 col-md-5">
        <CheckoutForm @submit="submitForm"/>
      </div>
      </div>
      </div>
        <FooterView/>
    </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar.vue';
import ProductList from '../components/ProductList.vue';
import FooterView from '../components/Footer.vue'
import CheckoutForm from '@/components/CheckoutForm.vue';
export default {
  name: 'CheckoutScreen',
  components: {
    NavigationBar,
    ProductList,
    FooterView,
    CheckoutForm
  },
  computed:{
    cartTotal(){
      let total = 0
      this.$store.state.cart.forEach((product)=>{
        total += product.price
      })
      return "$" + total + ""
    }
  },
  methods:{
    submitForm(data){
      console.log("Email" + " " + data)
    }

  }
  
}
</script>

<style scoped>
.root{
  display: flex;
  flex-direction: column;
  height: 100%; /* or 100vh if it's the viewport */
}
.content{
  flex: 1; /* takes all available space */
}
</style>